<template>
  <div class="hb-metric">
    <div class="hb-metric__label">{{ label }}</div>
    <div class="hb-metric__value">
      <slot>{{ value }}</slot>
    </div>
    <div v-if="hasDelta" class="hb-metric__delta" :class="deltaClass">
      <feather-icon :icon="deltaUp ? 'ArrowUpIcon' : 'ArrowDownIcon'" size="12" />
      <span>{{ deltaLabel }}</span>
    </div>
  </div>
</template>

<script>
/**
 * Celula do strip de desempenho: rotulo, valor e a variacao contra o periodo anterior.
 *
 * O valor entra ja formatado (por texto ou pelo slot, quando e um HbMoney), porque cada
 * metrica tem a sua unidade — contagem, porcentagem, dinheiro.
 */
export default {
  name: 'HbMetric',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    /**
     * Variacao contra o periodo anterior. Percentual (22 = +22%) por padrao; para metricas
     * que ja sao percentuais (conversao), passe a diferenca em pontos e use unit='pp'.
     * `null` esconde a linha — e o caso quando nao ha periodo anterior com que comparar.
     */
    delta: { type: Number, default: null },
    unit: { type: String, default: '%', validator: v => ['%', 'pp'].includes(v) },
    /** Metricas em que cair e bom (nao ha nenhuma hoje, mas o strip e generico). */
    inverse: { type: Boolean, default: false },
  },
  computed: {
    hasDelta() {
      return this.delta !== null && this.delta !== undefined && Number.isFinite(Number(this.delta))
    },
    deltaUp() {
      return Number(this.delta) >= 0
    },
    deltaClass() {
      const good = this.inverse ? !this.deltaUp : this.deltaUp

      return good ? 'hb-metric__delta--up' : 'hb-metric__delta--down'
    },
    deltaLabel() {
      const abs = Math.abs(Number(this.delta))
      const formatted = abs.toLocaleString('pt-BR', {
        minimumFractionDigits: this.unit === 'pp' ? 1 : 0,
        maximumFractionDigits: 1,
      })

      return this.unit === 'pp' ? `${formatted} p.p.` : `${formatted}%`
    },
  },
}
</script>

<style scoped>
.hb-metric {
  background: var(--surface-card);
  padding: 1rem 1.1rem;
  min-width: 0;
}

.hb-metric__label {
  font-size: var(--fs-sm);
  color: var(--text-muted);
}

.hb-metric__value {
  margin-top: 0.3rem;
  font-size: var(--fs-h2);
  font-weight: var(--fw-medium);
  color: var(--text-heading);
  line-height: 1.2;
}

.hb-metric__delta {
  margin-top: 0.2rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: var(--fs-xs);
}

.hb-metric__delta--up {
  color: var(--success);
}

.hb-metric__delta--down {
  color: var(--danger);
}
</style>
